import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  useCreateBrandDataMutation,
  useDeleteBrandInfoMutation,
  useGetAllBrandDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { toast } from "react-toastify";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import EditPage from "./EditBrand";
import DeleteModal from "../DeleteModal";
import useThemeColors from "../ThemeColors";
import LoadingSpinner from "../../../components/LoadingSpinner";

interface IPROPS {
  setLiftingName: any;
}

const ITEMS_PER_PAGE = 20;

const Make: React.FC<IPROPS> = ({ setLiftingName }) => {
  const [brandName, setBrandName] = useState("");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [storedData, setStoredData] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalCount] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);

  const [vehicleTableData, setVehicleTableData] = useState([]);

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);

  const [createVehicleTrigger] = useCreateBrandDataMutation();
  const {
    data: vehicleData,
    status,
    refetch,
    isLoading,
  } = useGetAllBrandDataQuery({
    page: currentPage,
    page_size: ITEMS_PER_PAGE
  });
  const [deleteTrigger] = useDeleteBrandInfoMutation();

  useEffect(() => {
    if (status === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [status]);

  useEffect(() => {
    if (vehicleData) {
      setVehicleTableData(vehicleData?.results || []);
      setTotalCount(vehicleData?.count || 0);
    }
  }, [vehicleData]);

  const name = "Vehicle Information";

  useEffect(() => {
    setLiftingName(name);
  }, [setLiftingName]);

  const createVehicleDataHandler = async () => {
    const obj = {
      name: brandName,
    };

    try {
      await createVehicleTrigger(obj).unwrap();

      toast.success("Data added successfully");
      setBrandName("");
      refetch();
    } catch (error: any) {
      if (error?.data?.name?.length) {
        toast.error(error.data.name[0]); // ✅ shows "brand with this name already exists."
      } else if (error?.data?.non_field_errors?.length) {
        toast.error(error.data.non_field_errors[0]);
      } else {
        toast.error("An unexpected error occurred");
      }
      console.error("Create Vehicle API Error:", error);
    }
  };

  const editHandler = (vehicle) => {
    setOpenEditModal(true);
    setStoredData(vehicle);
  };

  const closeModal = () => {
    setOpenEditModal(false);
    setOpenDeleteModal(false);
  };

  const deleteHandler = (vehicle) => {
    setStoredData(vehicle);
    setOpenDeleteModal(true);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };

  const {
    selectedColor,

    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };

  return (
    <div className="vehicle-info-cont">
            <div className="workshops-container">
      {tableLoader ? (
        <LoadingSpinner />
      ) : (
        <>
          <div
            className="vehicle-info-middle"
            style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
          >
            <div className="vehicle-info-middle-heading">Add Brand</div>
            <div
              className="vehicle-info"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ width: "100%" }}>
                <p className="vehicle-class">
                  <span
                    className="required"
                    style={{
                      paddingLeft: "10px",
                      fontFamily: "Karbon-medium",
                      fontSize: "18px",
                    }}
                  >
                    Brand
                  </span>
                  <span>
                    <input
                      style={{
                        borderRadius: "20px",
                        background: "#FCFCFC",
                        fontFamily: "Karbon-regular",
                      }}
                      className="form-control"
                      type="text"
                      onChange={(e) => setBrandName(e.target.value)}
                      value={brandName}
                      placeholder="Add Brand"
                    />
                  </span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <button
                  onClick={createVehicleDataHandler}
                  disabled={!brandName.trim()}
                  style={{
                    background: !brandName.trim()
                      ? "#F7D3C5"
                      : `${selectedButtonBackgoundColors}`,

                    color: `${selectedButtonColors}`,
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "20px",
                    fontSize: "15px",
                    cursor: brandName.trim() ? "pointer" : "not-allowed",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          <div
            className="vehicle-info-bottom mt-10"
            style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
          >
            <div className="vehicle-info-bottom-heading">Brands</div>
            <table className="vehicle-info-bottom-table">
              <thead className="thead">
                <tr className="tr">
                  <td>Sr.No.</td>
                  <td>Vehicle</td>
                  <td style={{ padding: "0 20px" }}>Action</td>
                  {/* <td>Model</td>
                            <td>Fuel type</td> */}
                </tr>
              </thead>
              <tbody className="table-body">
                {vehicleTableData?.map((vehicle, index) => (
                  <tr
                    className="table-body-tr"
                    style={{
                      background: index % 2 !== 0 ? "#FFF1EC" : "white",
                    }}
                  >
                    <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                    </td>
                    <td>{vehicle?.name}</td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span onClick={() => editHandler(vehicle)}>
                        <i
                          className="bi bi-pencil"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                        ></i>
                      </span>
                      {/* <span onClick={() => deleteHandler(vehicle)}>
                        <i
                          className="bi bi-trash3"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                        ></i>
                      </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

       
        </>
      )}

<div className="pagination-footer mb-10">
            <div className="pagination-info">
              Showing {startIndex + 1} - {endIndex} of {totalItems}
            </div>

            <div className="pagination-controls">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                Prev
              </button>

              {/* Always show exactly 5 page numbers, centered around current page */}
              {Array.from(
                { length: Math.min(5, totalPages) },
                (_, i) => {
                  // Calculate the first page to show (ensuring we always show 5 if possible)
                  let firstPage = Math.max(1, Math.min(
                    currentPage - 2,  // Try to center current page
                    totalPages - 4    // But don't go past total pages - 4
                  ));

                  const pageNum = firstPage + i;

                  return (
                    <button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      className={`pagination-btn ${pageNum === currentPage ? 'active' : ''}`}
                      style={{
                        display: pageNum > totalPages ? 'none' : 'inline-block',
                        margin: '0 2px',
                        minWidth: '32px',
                        textAlign: 'center'
                      }}
                    >
                      {pageNum}
                    </button>
                  );
                }
              )}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-btn"
              >
                Next
              </button>
            </div>
          </div>  

          </div>
  
      {/* <div className="vehicle-info-top" style={{display: "flex", justifyContent: "center"}}>
                <p className="vehicle-detail-buttons">
                    <span style={{ color: selectedColor, border: `1px solid ${selectedColor}`}}>Cancel</span>
                    <span onClick={createVehicleDataHandler} style={{background: selectedBackgroundColor}}>Save</span>
                </p>
            </div> */}
      <Modal
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <EditPage
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openDeleteModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <DeleteModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
              trigger={deleteTrigger}
              setTableData={setVehicleTableData}
              fieldsData={vehicleTableData}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Make;
